import { Button, useDisclosure } from '@chakra-ui/react';
import * as React from 'react';
import { Form, Modal } from '@lon/mathnation-suit/components';
import { useQueryParams } from '@lon/mathnation-suit/hooks';
import { FormValues, getValidation } from './duck';
import { ForgotPassword, LoginForm } from './components';
import { SelectForm } from './components';

const LoginButton: React.FC = () => {
  const [params, setParams] = useQueryParams();
  const { isOpen, onClose, onOpen } = useDisclosure();

  const [forgotPassword, setForgotPassword] = React.useState(false);
  return (
    <>
      <Button
        variant="solid"
        w="150px"
        mt="20px"
        background="#1da8d5"
        color="white"
        _hover={{ background: '#23baeb' }}
        _active={{ background: '#1891b8' }}
        onClick={onOpen}
      >
        Enter
      </Button>
      {isOpen && (
        <Modal
          bodyProps={{ maxH: 'initial', overflow: 'initial' }}
          isOpen
          onClose={onClose}
          size="xl"
        >
          {forgotPassword ? (
            <ForgotPassword onBack={() => setForgotPassword(false)} />
          ) : (
            <>
              {params.state ? (
                <LoginForm
                  onForgot={() => setForgotPassword(true)}
                  onChangeState={() => {
                    setParams({ ...params, state: null, district: null });
                  }}
                />
              ) : (
                <Form<FormValues> {...getValidation}>
                  <SelectForm />
                </Form>
              )}
            </>
          )}
        </Modal>
      )}
    </>
  );
};

export default LoginButton;
